import types from "cms/enums/contentsTypes.enum";
export var subPage = {
    label: "Sous-page",
    type: types.SUBPAGE,
    editionModal: true,
    editionModalPosition: "top"
};
